module.exports = __webpack_public_path__ + "static/media/12PerformancePhotos.49b6a027.jpeg";